
import React from 'react';
import Layout from '@/components/layout/Layout';
import FarmList from '@/components/farms/FarmList';

const Farms: React.FC = () => {
  return (
    <Layout>
      <FarmList />
    </Layout>
  );
};

export default Farms;
